import { render, staticRenderFns } from "./MonitorRamaisCallCenter.vue?vue&type=template&id=4ee2de7b&scoped=true&"
import script from "./MonitorRamaisCallCenter.vue?vue&type=script&lang=js&"
export * from "./MonitorRamaisCallCenter.vue?vue&type=script&lang=js&"
import style0 from "./MonitorRamaisCallCenter.vue?vue&type=style&index=0&id=4ee2de7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2de7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAppBar,VAutocomplete,VBtn,VCard,VCardActions,VCardTitle,VCol,VDialog,VDivider,VIcon,VRow,VSelect,VSkeletonLoader,VSpacer,VSwitch})
